import React from 'react';
import classNames from 'classnames';
import styles from '../assets/payment-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { IPayment } from 'src/types/payment';
import PaymentActionsColumn from './PaymentActionsColumn';
import { CellProps } from 'react-table';
import { Link } from 'react-router-dom';
import Router from '../../../../../../../navigation/router';
import { routes } from '../../../../../../../navigation';
import GeneralEnum from '../../../../../../../enumerables/general-enum';
import { getValFromEnum } from '../../../../../../../components/redux-form/utils/dropdown-values';
import dropdownFilter from '../../../../../../../components/react-table/filters/dropdown-filter';
import dateFilter from '../../../../../../../components/react-table/filters/date-filter';
import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';
import { numberWithCommas } from '../../../../../../../helpers/format';

interface Props {
    data: Paginated<IPayment>;
    getData: (params: QueryParams) => void;
}

const generalEnum = GeneralEnum ? GeneralEnum.getEnum('PaymentStatus') : {};
const statusTypes: SelectObject[] = getValFromEnum(generalEnum);
const columns: Column<IPayment>[] = [
    {
        Header: 'ID',
        accessor: 'id',
        disableSortBy: true,
        Filter: textFilter<IPayment>(),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IPayment>) => (
            <Link className={'mr-1'} to={Router.generate(routes.PAYMENT_DETAIL, { id: original.id })}>
                {original.id}
            </Link>
        ),
    },
    {
        Header: 'Payment Date',
        accessor: 'paymentDate',
        disableSortBy: true,
        Filter: dateFilter<IPayment>(),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IPayment>) => changeToZeroMoment(original.paymentDate, 'MMM D, YYYY'),
    },
    {
        Header: 'Check/EFT Info',
        accessor: 'eftInfo',
        disableSortBy: true,
        Filter: textFilter<IPayment>(),
    },
    {
        Header: 'Amount, $',
        accessor: 'amount',
        disableSortBy: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IPayment>) => (original.amount ? `$${numberWithCommas(original.amount)}` : '$0.00'),
        Filter: textFilter<IPayment>(),
    },
    {
        Header: 'Status',
        disableSortBy: true,
        accessor: 'status',
        Filter: dropdownFilter<IPayment>(statusTypes),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IPayment>) => {
            const valuestatus = statusTypes.find((it) => +it.value === +original.status);

            return valuestatus ? valuestatus.label : '';
        },
    },

    {
        Header: 'Actions',
        disableSortBy: true,
        accessor: 'createdAt',
        Cell: PaymentActionsColumn,

        disableFilters: true,
        width: '10%',
    },
];

const PaymentsGrid: React.FunctionComponent<Props> = ({ data, getData }: Props) => (
    <div className={classNames(styles.grid)}>
        <Grid<IPayment> columns={columns} data={data} getData={getData} />
    </div>
);

export default PaymentsGrid;
